import React from 'react';
import { Button } from '@mui/material';
import { Google as GoogleIcon } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';

interface LoginButtonProps {
  variant?: 'contained' | 'outlined' | 'text';
  size?: 'small' | 'medium' | 'large';
  fullWidth?: boolean;
}

const LoginButton: React.FC<LoginButtonProps> = ({ 
  variant = 'contained', 
  size = 'medium',
  fullWidth = false 
}) => {
  const { login, isLoading } = useAuth();

  return (
    <Button
      variant={variant}
      size={size}
      fullWidth={fullWidth}
      startIcon={<GoogleIcon />}
      onClick={login}
      disabled={isLoading}
      sx={{
        backgroundColor: variant === 'contained' ? '#4285f4' : undefined,
        color: variant === 'contained' ? 'white' : '#4285f4',
        '&:hover': {
          backgroundColor: variant === 'contained' ? '#3367d6' : undefined,
        },
        textTransform: 'none',
        fontWeight: 500
      }}
    >
      {isLoading ? 'Loading...' : 'Sign in with Google'}
    </Button>
  );
};

export default LoginButton; 